// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PicCenterOutlinedSvg from "@ant-design/icons-svg/es/asn/PicCenterOutlined";
import AntdIcon from '../components/AntdIcon';

var PicCenterOutlined = function PicCenterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PicCenterOutlinedSvg
  }));
};

PicCenterOutlined.displayName = 'PicCenterOutlined';
export default React.forwardRef(PicCenterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PicCenterOutlined.js
// module id = 1559
// module chunks = 0